export default "__VITE_ASSET__bGw7aWyV__"